import { Box, Button, Checkbox, DialogActions, DialogContent, FormControl, IconButton, MenuItem, Select, Stack, Tooltip } from "@mui/material"
import { useState } from "react";

import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import RestoreIcon from '@mui/icons-material/Restore';
import { useFunctions } from "reactfire";
import { useContextAuth } from "../../../../authContext/AuthHook";
import { setIsStarred } from "../../../../firebase/functions/setIsStarred";
import DeleteIcon from '@mui/icons-material/Delete';
import { setSessionStatusFunc } from "../../../../firebase/functions/cloudFunctions/setSessionStatus";
import { BootstrapDialog, BootstrapDialogTitle } from "../../../utils/bootstrapDialog";
import { SessionParamsEnum } from "../../../../enums";
import { useSessionParams } from "../../../../contexts";

export const RemoveSessionField = ({ row }) => {
    const sessionID = row?.id;
    const sessionStatus = row?.status;
    const sessionParams = useSessionParams();
    const [settingData, setSettionData] = useState(false);
    const { user } = useContextAuth();
    const functions = useFunctions();
    const isDeletedSession = sessionStatus === 'removed' ? true : false;

    const [openModal, setOpenModal] = useState(false);
    const handleModalOpen = () => { setOpenModal(true) }
    const handleModalClose = () => { setOpenModal(false) }

    const [openModalRestore, setOpenModalRestore] = useState(false);
    const handleModalRestoreOpen = () => { setOpenModalRestore(true) }
    const handleModalRestoreClose = () => { setOpenModalRestore(false) }
    const [newSessionStatus, setNewSessionStatus] = useState('-');

    const handleChangeStatus = (event) => {
        setNewSessionStatus(event.target.value);
    };

    const handleRemoveSessom = () => {
        console.log("Remove session: ", sessionID);

        setSessionStatusFunc(functions, sessionID, 'removed').then(() => {
            handleModalClose();
        }).catch((error) => {
            console.error("FB Error: ", error);
        }).finally(() => {
            setSettionData(false);
        });
    }

    const handleRestoreSessom = () => {
        console.log("Restore session: ", sessionID);
        let sessionChange = newSessionStatus;
        if (newSessionStatus === '-'){
            sessionChange = "";
        }
        setSessionStatusFunc(functions, sessionID, sessionChange).then(() => {
            handleModalRestoreClose();
        }).catch((error) => {
            console.error("FB Error: ", error);
        }).finally(() => {
            setSettionData(false);
        });
    }

    return (
        <>
            {sessionID !== SessionParamsEnum.SessionID.getContextValue(sessionParams) ? (
                <>
                    {isDeletedSession === true ? (
                        <Tooltip title={"Återställ session?"}>
                            <Stack direction={'row'} alignItems={'center'}>
                                <IconButton disabled={settingData} size="small" onClick={handleModalRestoreOpen}>
                                    <RestoreIcon />
                                </IconButton>
                            </Stack>
                        </Tooltip>

                    ) : (
                        <Stack direction={'row'} alignItems={'center'}>
                            <IconButton disabled={settingData} size="small" onClick={handleModalOpen}>
                                <DeleteIcon />
                            </IconButton>
                        </Stack>
                    )}


                    <BootstrapDialog
                        onClose={handleModalClose}
                        aria-labelledby="remove-session-modal"
                        open={openModal}
                    >

                        <BootstrapDialogTitle onClose={handleModalClose}>
                            Ta bort session?
                        </BootstrapDialogTitle>

                        <DialogContent sx={{ width: '400px' }} dividers>
                            Är du säker på att du vill ta bort {sessionID}?
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleRemoveSessom} variant="outlined">
                                Radera
                            </Button>
                            <Button variant="outlined" onClick={handleModalClose}>Avbryt</Button>
                        </DialogActions>
                    </BootstrapDialog>

                    <BootstrapDialog
                        onClose={handleModalRestoreClose}
                        aria-labelledby="restore-session-modal"
                        open={openModalRestore}
                    >

                        <BootstrapDialogTitle onClose={handleModalRestoreClose}>
                            Återställ session?
                        </BootstrapDialogTitle>

                        <DialogContent sx={{ width: '400px' }} dividers>
                            <Stack alignItems={'center'} justifyContent={'center'} spacing={2}>
                                <Box>
                                    Är du säker på att du vill återställa {sessionID}?
                                </Box>
                                <Box>
                                    <FormControl sx={{ width: '200px' }}>
                                        <Select
                                            value={newSessionStatus}
                                            onChange={handleChangeStatus}
                                        >
                                            <MenuItem value={'-'}>Generell</MenuItem>
                                            <MenuItem value={'test'}>Test/debugg</MenuItem>
                                            <MenuItem value={'archived'}>Arkiverad</MenuItem>
                                            <MenuItem value={'altConfig'}>Alternativt utförande</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Stack>

                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleRestoreSessom} variant="outlined">
                                Återställ
                            </Button>
                            <Button variant="outlined" onClick={handleModalRestoreClose}>Avbryt</Button>
                        </DialogActions>
                    </BootstrapDialog>
                </>
            ) : ("")}

        </>
    );
}